export default "/images/photos-grid-2.png?6e4c0b0bc41a8c491a0649ff6138e700";